import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from '@material-ui/icons';

import nakedNewsLogo from '../../assets/logo-naked-news.png';
import nudeNewsLogo from '../../assets/nudenews-logo.png';
import anchorPortalLogo from '../../assets/anchor-portal-logo.png';
import nakedNewsLogoWhite from '../../assets/Affiliate/Logos Icons/NN-logo.png';
import nakedNewsLiveLogo from '../../assets/NakedNewsLive/NNL_192x36.png';
import { isNakedNewsLiveDomain, isNudeDomain } from '../../utils/helpers';
import CountdownTimerComponent from '../generalComponents/CountdownTimerComponent/CountdownTimerComponent';


const HeaderLogoAndDropDown = ({ location, toggleMobileHeader, isAnchorPortal, activeCampaign, user, userPremiumExpired }) => {
  const decideLogo = useCallback(() => {
    if (isAnchorPortal) {
      return anchorPortalLogo;
    }

    if (isNudeDomain) {
      return nudeNewsLogo;
    }

    if (isNakedNewsLiveDomain) {
      return nakedNewsLiveLogo;
    }

    if (location?.pathname === '/affiliates') {
      return nakedNewsLogoWhite;
    }

    return nakedNewsLogo;
  }, [isAnchorPortal, location?.pathname]);

  const logo = decideLogo();

  return (
    <div
      className={`navbar-header ${isAnchorPortal ? 'anchor-portal-topnav-header' : ''}`}
      id="navbar-header"
    >
      <button
        className={`${
          isAnchorPortal ? 'anchor-portal-topnav-toggle' : 'navbar-toggle navbar-toggle-custom'
        }`}
        type="button"
        onClick={toggleMobileHeader}
      >
        <span className="sr-only">Toggle navigation</span>
        <Menu fontSize="inherit" />
      </button>

      {(userPremiumExpired || (user && !user.authenticated)) && activeCampaign && activeCampaign.hasTimer && activeCampaign.secondsLeft &&
        <div className="navbar-toggle navbar-toggle-custom navbar-toggle-custom-countdown">
          <CountdownTimerComponent activeCampaign={activeCampaign} />
        </div>
      }

      {/* {isAnchorPortal && (
        <button className="anchor-portal-topnav-toggle anchor-portal-topnav-header__camera">
          <Link to="/dashboard/broadcast" target={'_self'} style={{color: 'white'}}>
            <Videocam
              fontSize="inherit"
              color="white"
            />
          </Link>
        </button>
      )} */}
      <div className="hidden-xs">
        <Link className="navbar-brand" to={isAnchorPortal ? '/dashboard' : '/'}>
          <img
            alt="Naked News: The Program With Nothing To Hide"
            className={`img-responsive ${isAnchorPortal ? 'anchor-portal-logo' : ''}`}
            src={logo}
          />
        </Link>
      </div>
      <div className="visible-xs">
        <Link
          className={`navbar-brand ${isAnchorPortal ? '' : 'navbar-brand-custom'}`}
          to={isAnchorPortal ? '/dashboard' : '/'}
        >
          <img
            alt="Naked News: The Program With Nothing To Hide"
            className={`img-responsive ${isAnchorPortal ? 'anchor-portal-logo' : ''}`}
            src={logo}
          />
        </Link>
      </div>
    </div>
  );
};

export default HeaderLogoAndDropDown;
